export default __webpack_public_path__ + "static/media/rohan.015153df.webp";